var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 10 } },
    [
      _c("el-col", { attrs: { md: 8 } }, [
        _c("div", { staticClass: "container-perfil column margin" }, [
          _c("img", {
            staticClass: "item-perfil img-perfil",
            attrs: { src: require("../../../../assets/icons/employee.svg") }
          }),
          _c("span", { staticClass: "item-perfil" }, [
            _vm._v(_vm._s(_vm.usuario ? _vm.usuario.toUpperCase() : "-"))
          ]),
          _c("span", { staticClass: "item-perfil" }, [
            _vm._v(_vm._s(_vm.totalLabel))
          ])
        ])
      ]),
      _c(
        "el-col",
        { attrs: { md: 8 } },
        [
          _c("app-plotly", {
            attrs: {
              nomeDiv: "graficoProdutividadeAnalista",
              dados: _vm.graficoDados,
              layout: _vm.layout,
              centralizarGrafico: true
            }
          })
        ],
        1
      ),
      _c("el-col", { attrs: { md: 8 } }, [
        _c(
          "section",
          { staticClass: "container column margin" },
          _vm._l(_vm.dadosWithColors, function(item) {
            return _c(
              "div",
              { staticClass: "item" },
              [
                _c(
                  "el-tag",
                  {
                    staticClass: "color-text-tag",
                    attrs: { size: "small", color: item.color }
                  },
                  [_vm._v(_vm._s(item.quantidade))]
                ),
                _c("span", [_vm._v(_vm._s(item.tipoProcesso))])
              ],
              1
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8fcb8f90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fcb8f90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/components/produtividadeAnalista/GraficoProdutividade.vue
// module id = null
// module chunks = 